import { TabNode } from "../model/TabNode";
import { CLASSES } from "../CSSClassNames";
import { getViewController, LayoutInternal } from "./layout/LayoutInternal";

export interface ITabLayoutProps {
    tabNode: TabNode;
}
/**
 * Component that can be used within the factory to render a tabs defined sublayout.
 * This allows the sublayout to be surrounded by other controls, e.g. a header and footer bars
 *
 * @category Components
 * @group Main Layout
 */
export const TabLayout = (props: ITabLayoutProps) => {
    const { tabNode } = props;

    const controller = getViewController(tabNode.getLayout());

    if (!controller) return;

    const model = tabNode.getModel();
    const subLayout = model.getLayouts().get(tabNode.getSubLayoutId()!)!;
    return (
        <div className={controller.getClassName(CLASSES.FLEXLAYOUT__TAB_LAYOUT_CONTAINER_USER)}>
            <LayoutInternal {...controller.getProps()} layoutId={tabNode.getSubLayoutId()} path={tabNode.getPath() + subLayout.getPath()} mainLayoutController={controller.getMainController()} />
        </div>
    );
};
